import { FC, useCallback } from "react";
import { useAppSelector } from "../../../../../../../../../../../../../store/hooks";
import { currentAccountIdSelector } from "../../../../../../../../../../../../../store/account/selectors/current-account/currentAccountIdSelector";
import { ConfirmationDialog } from "../../../../../../../../../../../../common/modals/ConfirmationDialog";

interface ProtectDialogProps {
  isProtected: boolean;
  onClose(): void;
  onConfirm?: () => void;
  isLoading: boolean;
}

export const ProtectDialog: FC<ProtectDialogProps> = ({
  onClose,
  isProtected,
  onConfirm,
  isLoading,
}) => {
  const accountId = useAppSelector(currentAccountIdSelector);

  const handleProtectClick = useCallback(() => {
    if (!accountId) {
      return;
    }
    onConfirm?.();
  }, [accountId, onConfirm]);

  return (
    <ConfirmationDialog
      open
      title={!isProtected ? "Enable Protection?" : "Disable Protection?"}
      dialogContent={
        !isProtected
          ? "Resources with Enabled Protection will be untouched by Cloudchipr."
          : "Users with sufficient permissions can take actions on resources with Disabled Protection."
      }
      CancelButtonProps={{
        onClick: onClose,
      }}
      ConfirmButtonProps={{
        children: !isProtected ? "Enable" : "Disable",
        onClick: handleProtectClick,
        loading: isLoading,
      }}
      onClose={onClose}
    />
  );
};
